import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { maxTabs } from '@/config'
import { aesDecrypt } from '@/utils/ase'

Vue.use(VueRouter)

export const constantRoutes = [
  {
    path: '/',
    name: 'Workbench',
    component: () => import('@/views/Workbench.vue'),
    meta: { title: '企业工作台', hidden: true },
  },
  {
    path: '/process',
    name: 'Process',
    component: () => import('@/views/Process/index.vue'),
    meta: { title: '流程面板', hidden: true },
  },
  {
    path: '/process/add/:terminalType/:tenant/:key',
    name: 'ProcessAdd',
    component: () => import('@/views/Process/renderer/add.vue'),
    meta: { title: '创建流程', hidden: true },
  },
  {
    path: '/process/edit/:terminalType/:tenant/:key/:processInstanceId/:taskId',
    name: 'ProcessEdit',
    component: () => import('@/views/Process/renderer/edit.vue'),
    meta: { title: '编辑流程', hidden: true },
  },
  {
    path: '/process/detail/:terminalType/:tenant/:key/:processInstanceId/:taskId',
    name: 'ProcessDetail',
    component: () => import('@/views/Process/renderer/detail.vue'),
    meta: { title: '查看流程', hidden: true },
  },
  {
    path: '/process/checked/:terminalType/:tenant/:key/:processInstanceId/:taskId',
    name: 'ProcessChecked',
    component: () => import('@/views/Process/renderer/checked.vue'),
    meta: { title: '审批流程', hidden: true },
  },
  {
    path: '/encryptedPage/:encrypted',
    name: 'EncryptedRouteHandler',
    component: () => import('@/views/EncryptedRouteHandler.vue'),
    beforeEnter: (to, from, next) => {
      try {
        const decrypted = aesDecrypt(to.params.encrypted)
        to.meta.decryptedPath = decrypted
        next()
      } catch (error) {
        next('/error') // 解密失败跳转到错误页
      }
    },
    meta: { title: '中间页', hidden: true },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', hidden: true },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: { title: '404', hidden: true },
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401.vue'),
    meta: { title: '401', hidden: true },
  },
  {
    path: '*',
    redirect: '404',
    meta: { title: 'not Found', hidden: true },
  },
]

// 开发环境下，添加一些本地用于模拟测试的路由
// if (process.env.NODE_ENV === 'development') {
//   const mockRoutes = require('../../test/routes.js').default
//   constantRoutes.push(...mockRoutes)
// }

function createRouter() {
  return new VueRouter({
    mode: 'history',
    routes: constantRoutes,
  })
}
const router = createRouter()

export function resetRouter() {
  router.matcher = createRouter().matcher
}

const originalPush = router.push
router.push = function (...args) {
  const location = this.match(args[0])
  const visiteRoutes = store.getters['tabsBar/visiteRoutes']
  const target = visiteRoutes.find((item) => item.path === location.path)
  if (!target && visiteRoutes?.length > maxTabs) {
    const message = `最多只能打开${maxTabs + 1}个页面，请先关闭部分页面。是否关闭前五个页面？`
    Vue.prototype
      .$mgAlert(message, '提示', { confirmButtonText: '关闭并打开新页面' })
      .then(() => {
        const changePages = store.getters['tabsBar/changePages']
        if (visiteRoutes.some((item) => changePages.includes(item?.name))) {
          return Vue.prototype.$mgConfirm('当前页面正在编辑，确认关闭?')
        }
      })
      .then(() => {
        visiteRoutes.slice(1, 5).forEach((route) => store.dispatch('tabsBar/removeTab', route))
        originalPush.call(this, ...args)?.catch(() => {})
      })
    return
  }
  return originalPush.call(this, ...args)?.catch(() => {})
}

export default router
